export interface InformationDialogData {
  icon: string;
  title: string;
  message: string;
  close: string;
}
